import React, {PropTypes as T} from 'react';
import translate from '../../../utils/translate';
import modalActions from '../../../actions/modal';
import Messages from '../../../components/edp/messages';
import {venueNameCity} from './eventinfo_utils';

const EventDateTime = T.shape({
  day: T.string,
  dayName: T.string,
  month: T.string,
  monthName: T.string,
  time: T.string,
  year: T.string
});

const EventLocation = T.shape({
  city: T.string,
  country: T.string,
  latitude: T.string,
  longitude: T.string,
  region: T.string,
  state: T.string,
  streetAddress1: T.string,
  streetAddress2: T.string,
  streetAddress3: T.string,
  zip: T.string
});

const EventImage = T.shape({
  altText: T.string,
  titleText: T.string,
  url: T.string
});

const EventConfig = T.shape({
  eventId: T.string,
  type: T.string,
  pageProtection: T.bool,
  urls: T.shape({
    protection: T.shape({
      page: T.string,
      priceType: T.string
    }),
    deliveryInfo: T.string,
    checkout: T.shape({
      ism: T.string,
      suggestuions: T.string
    }),
    moreDates: T.string
  }),
  ticketLimit: T.integer,
  memberTicketLimit: T.number,
  feeDisclaimer: T.bool,
  platinum: T.bool,
  avoidSingleSeats: T.bool
});

export default class EventInfo extends React.Component {
  static propTypes = {
    modal: T.object,
    name: T.string,
    description: T.string,
    eventId: T.string,
    ageRestriction: T.string,
    maxTickets: T.number,
    hasReservation: T.bool,
    isHiddenDate: T.bool,
    isHiddenTime: T.bool,
    image: EventImage,
    eventDateTime: EventDateTime,
    eventDateTimeString: T.string,
    onsaleEndDateTime: EventDateTime,
    onsaleStartDateTime: EventDateTime,
    reservationEndDateTime: EventDateTime,
    reservationStartDateTime: EventDateTime,
    venue: T.shape({
      location: EventLocation,
      name: T.string,
      url: T.string
    }),
    promoter: T.shape({
      location: EventLocation,
      name: T.string
    }),
    eventconfig: EventConfig,
    appearance: T.shape({
      page_class: T.string,
      cbt_suppression: T.bool
    })
  };

  constructor (props) {
    super(props);

    // const isCheckout = props.appearance && props.appearance.page_class === 'checkout';
    const isEDP = !props.appearance || props.appearance.page_class === 'edp';
    const isCBTSuppress = props.appearance && props.appearance.cbt_suppression;
    const showEventImage = !isCBTSuppress;
    const showModal = isEDP && !isCBTSuppress;

    this.state = {
      appearance: {

        // Event image
        showEventImage: showEventImage,
        headerClass: 'eventinfo__main has-img is-fullwidth' + (showEventImage ? ' has-evt-img' : ''),

        // Modal
        showModal: showModal,
        eventcardClass: showModal ? 'eventcard' : 'eventcard--suppressinfo',
        showEventCardIcon: showModal,
        showEventCardButton: showModal
      }
    };
  }

  renderLargeAgeRestriction = (ageRestrictionText) => {
    return this.props.ageRestriction &&
      <div className="eventcard__body__agerestriction--largeonly">
        {ageRestrictionText}
      </div>;
  };

  renderSmallAgeRestriction = (ageRestrictionText) => {
    return this.props.ageRestriction &&
      <div className="eventcard__body__agerestriction--smallonly">
        {ageRestrictionText}
      </div>;
  };

  renderDayTime = () => {
    if (this.props.isHiddenDate) {
      return `${translate('eventInfoModule', 'HIDDEN_DATE')}`;
    }
    else if (this.props.isHiddenTime) {
      return `${this.props.eventDateTime.dayName}, ${translate('eventInfoModule', 'HIDDEN_TIME')}`;
    }
    else {
      return (`${this.props.eventDateTime.dayName}, ${this.props.eventDateTime.time}`);
    }
  };

  onClickHeader = () => {
    if (this.state.appearance.showModal) {
      modalActions.show();
    }
  };

  render () {
    const ageRestrictionText = `${translate('eventInfoModule', 'AGE_RESTRICTION')}, ${this.props.ageRestriction}+`;
    const eventInformationText = `${translate('eventInfoModule', 'EVENT_INFORMATION')}`;
    const appearance = this.state.appearance;

    return (
      <div
        role="region"
        className={appearance.headerClass}
        data-component="eventinfo-header"
        aria-label={eventInformationText}
      >
        <div
          className="eventinfo__main__bg"
          style={{ backgroundImage: `url(${this.props.image.url})`}}
        />

        {
          appearance.showEventImage &&
          <img
            className="eventinfo__main__img"
            src={this.props.image.url}
            alt={this.props.image.altText}
            title={this.props.image.titleText}
            aria-hidden="true"
          />
        }

        <div className="eventinfo__main__info">
          <div className={appearance.eventcardClass}>
            {
              !this.props.isHiddenDate &&
              <div className="datebox">
                <div className="datebox__month">{ this.props.eventDateTime.monthName }</div>
                <div className="datebox__day">{ this.props.eventDateTime.day }</div>
                <div className="datebox__year">{ this.props.eventDateTime.year }</div>
              </div>
            }

            <div className="eventcard__body">
              <div className="eventcard__body__when">
                {this.renderDayTime()}
              </div>
              <h1 className="eventcard__body__name">{ this.props.name }</h1>
              <div className="eventcard__body__venue">
                {venueNameCity(this.props.venue)}
              </div>
              {this.renderLargeAgeRestriction(ageRestrictionText)}
            </div>
            {appearance.showEventCardIcon && <i className="eventcard__icon" />}
            {this.renderSmallAgeRestriction(ageRestrictionText)}
            {appearance.showEventCardButton &&
              <button
                className="eventcard__toggle"
                data-accordion-trigger="eventinfo"
                aria-label={eventInformationText}
                title={eventInformationText}
                onClick={this.onClickHeader}
              />
            }
          </div>
        </div>
        <Messages
          modal={this.props.modal}
          eventInfoName={this.props.name}
          venue={this.props.venue}
          eventDateTimeString={this.props.eventDateTimeString}
          eventDateTime={this.props.eventDateTime}
          eventInfoDescription={this.props.description}
          promoter={this.props.promoter}
          isHiddenDate={this.props.isHiddenDate}
          isHiddenTime={this.props.isHiddenTime}
          moreDatesUrl={this.props.eventconfig.urls.moreDates}
          showModal={appearance.showModal} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/eventinfo/index.js